"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPreviewDispositionOne = void 0;
const organization_1 = require("./organization");
const utils_1 = require("../utils");
const base = Object.assign({ id: 1, organization_id: (0, organization_1.mockChildOrganization)().id, title: 'Global disposition One', parents: null, global: true, conversation_form_id: null }, utils_1.mockDateObject);
exports.mockPreviewDispositionOne = (0, utils_1.mockFunction)(Object.assign({}, base));
